import BannerServices from 'components/Banner/Services';
import ContactUs from 'components/ContactUs/ContactUs';
import OurKeyService from 'components/OurKeyService/OurKeyService';
import WhyUs from 'components/WhyUs/WhyUs';
import useTheme from 'hooks/useTheme';
import Head from 'next/head';

function Services(): JSX.Element {
  useTheme({
    light: false,
  });

  return (
    <>
      <Head>
        <title>Services: Spirit Labs | Your Software Development Company</title>
        <link rel="canonical" href={`${process.env.URL}/services`} />
        <meta
          name="description"
          content="We commit to providing you cost-effective and scalable solutions for your company whether you need a native mobile app or a marketplace platform"
        />
      </Head>

      <BannerServices />
      <OurKeyService />
      <WhyUs />
      <ContactUs />
    </>
  );
}

export default Services;
